export default __webpack_public_path__ + "static/media/rentals_consider.ae071b5a.png";